import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { formatImageName } from "../utils/functions";
import "swiper/css";
import "swiper/css/navigation";

const CategoryItem = ({ category, subcategories }) => {
  return (
    <li className="has-submenus-submenu">
      <Link to="#" className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0">
        <span>{category.name}</span>
        <span className="icon text-md d-flex ms-auto">
          <i className="ph ph-caret-right" />
        </span>
      </Link>
      <div className="submenus-submenu py-16">
        <h6 className="text-lg px-16 submenus-submenu__title">{category.name}</h6>
        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
          {subcategories.map((item) => (
            <li key={item._id}>
              <Link to={`/products?category=${category._id}&subcategory=${item._id}`}>{item.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};

const BannerTwo = ({ banners, categories, subcategories }) => {
  return (
    <div className="banner-two">
      <div className="container container-lg">
        <div className="banner-two-wrapper d-flex align-items-start">
          {/* Categories Section */}
          <div className="w-265 d-lg-block d-none flex-shrink-0">
            <div className="responsive-dropdown style-two common-dropdown nav-submenu p-0 submenus-submenu-wrapper shadow-none border border-gray-100 position-relative border-top-0">
              <button
                type="button"
                className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
              >
                <i className="ph ph-x" />
              </button>
              <div className="logo px-16 d-lg-none d-block">
                <Link to="/" className="link">
                  <img src="assets/images/logo/logo.png" alt="Logo" />
                </Link>
              </div>
              <ul className="responsive-dropdown__list scroll-sm p-0 py-8 overflow-y-auto ">
                {categories.map((category) => (
                  <CategoryItem
                    category={category}
                    subcategories={subcategories.filter((item) => item.categoryId === category._id)}
                    key={category._id}
                  />
                ))}
              </ul>
            </div>
          </div>

          {/* Banner Section */}
          <div className="banner-item-two-wrapper overflow-hidden position-relative arrow-center flex-grow-1 mb-0">
            <div className="banner-item-two__slider">
              <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                slidesPerView={1}
                autoplay={{ delay: 3000 }}
                loop={true}
                navigation={false}
                speed={1000}
              >
                {banners.map((item) => (
                  <SwiperSlide key={item._id}>
                    <img src={formatImageName(item.imageUrl)} className="rounded w-100" alt="Banner" />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerTwo;
